import React, { useState } from 'react';
import {
  Container,
  Box,
  Grid,
  Card,
  Typography,
  Fade,
  alpha
} from '@mui/material';
import {
  ArrowForward as ArrowIcon,
  Category as CategoryIcon,
  Palette as DesignIcon,
  Movie as StoryIcon,
  AdUnits as AdIcon,
  Devices as ResponsiveIcon,
  TouchApp as TouchIcon
} from '@mui/icons-material';

import phoneAsset from '../assets/phone34.png';

const Features = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const mobileFeatures = [
    {
      icon: <ResponsiveIcon />,
      title: 'Her Cihazda Mükemmel',
      description: 'Telefon, tablet, bilgisayar - her cihazda kusursuz görünüm. Okuyucularınızın %70\'i mobilden gelir.',
      color: '#3b82f6',
      gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
    },
    {
      icon: <CategoryIcon />,
      title: 'Mobil Optimizasyonu',
      description: 'Mobil okuyucular için özel optimize edilmiş hız ve tasarım. Dokunmatik uyumlu arayüz.',
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981 0%, #047857 100%)'
    },
    {
      icon: <DesignIcon />,
      title: 'Hızlı Mobil Yükleme',
      description: 'Görseller otomatik optimize edilir. Mobilde de 1 saniyenin altında sayfa açılışı.',
      color: '#f59e0b',
      gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
    },
    {
      icon: <StoryIcon />,
      title: 'Mobil Story Özelliği',
      description: 'Instagram benzeri story formatı ile öne çıkan haberleri mobilde sürükleyici şekilde sunun.',
      color: '#ef4444',
      gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
    },
    {
      icon: <AdIcon />,
      title: 'Mobil Reklam Desteği',
      description: 'Mobil kullanıcılar için özel reklam alanları. Banner, native ve interstitial formatlar.',
      color: '#8b5cf6',
      gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)'
    },
    {
      icon: <TouchIcon />,
      title: 'Kolay Navigasyon',
      description: 'Mobilde kayan menüler ve kolay gezinme. Kullanıcı dostu arayüz tasarımı.',
      color: '#06b6d4',
      gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)'
    }
  ];

  return (
    <Box 
      sx={{
        backgroundColor:'#f1f6fb',
      }}
    >
      <Box
        sx={{
          borderRadius: {xs : 0, md : '400px 0 400px 0'},
          py: { xs: 10, md: 16 },
          background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Container maxWidth="xl">
          {/* Header */}
          <Box sx={{ textAlign: 'center', mb: 8, position: 'relative' }}>
            <Typography
              variant="overline"
              sx={{
                fontSize: '0.9rem',
                fontWeight: 900,
                letterSpacing: '0.1em',
                color: '#3b82f6',
                mb: 2,
                display: 'block',
                textTransform: 'uppercase'
              }}
            >
              MOBİL DENEYİM
            </Typography>

            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                mb: 3,
                color: 'white',
                lineHeight: 1.1
              }}
            >
              Her Cihazda Mükemmel Deneyim
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: '1.1rem', md: '1.3rem' },
                color: 'rgba(255, 255, 255, 0.8)',
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6,
                fontWeight: 400
              }}
            >
              Okuyucularınızın %70'i mobilden gelir. Telefon, tablet, bilgisayar - her cihazda kusursuz görünüm
            </Typography>
          </Box>

          <Grid container spacing={6} alignItems="center">
            {/* Mobile Phone Image - Sol Taraf */}
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  position: 'relative'
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                   // animation: 'float 6s ease-in-out infinite',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      inset: -40,
                      background: 'radial-gradient(circle, rgba(59, 130, 246, 0.3) 0%, transparent 70%)',
                      borderRadius: '50%',
                      filter: 'blur(40px)',
                      zIndex: -1
                    }
                  }}
                >
                  <Box
                    component="img"
                    src={phoneAsset}
                    alt="Responsive Tasarım"
                    sx={{
                      width: '100%',
                     // maxWidth: 350,
                      height: 'auto',
                      filter: 'drop-shadow(0 25px 50px rgba(0, 0, 0, 0.5))',
                      transition: 'all 0.4s ease',
                      '&:hover': {
                        transform: 'scale(1.05) rotate(-2deg)',
                      }
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Feature Cards - Sağ Taraf 2x3 Grid */}
            <Grid item xs={12} md={7}>
              <Grid container spacing={3} sx={{display: 'flex', alignItems : 'flex-end'}}>
                {mobileFeatures.map((feature, index) => (
                  <Grid item xs={12} md={6} key={index}>
                    <Fade in timeout={1000 + index * 200}>
                      <Card
                        elevation={0}
                        onMouseEnter={() => setHoveredCard(index)}
                        onMouseLeave={() => setHoveredCard(null)}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          p: 3,
                          height: '100%',
                          // background: hoveredCard === index 
                          //   ? 'rgba(255, 255, 255, 0.95)' 
                          //   : 'rgba(255, 255, 255, 0.05)',
                          background :'rgba(255, 255, 255, 0.05)',
                          backdropFilter: 'blur(20px)',
                          border: hoveredCard === index
                            ? `2px solid ${feature.color}`
                            : '1px solid rgba(255, 255, 255, 0.1)',
                          borderRadius: 3,
                          position: 'relative',
                          cursor: 'pointer',
                          transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                          overflow: 'hidden',
                          transform: hoveredCard === index 
                            ? 'translateY(-8px) scale(1.02)' 
                            : 'translateY(0)',
                          boxShadow: hoveredCard === index
                            ? `0 25px 50px ${alpha(feature.color, 0.3)}`
                            : 'none',
                          '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: 4,
                            background: feature.gradient,
                            transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
                            transformOrigin: 'left',
                            transition: 'transform 0.3s ease'
                          },
                          '&::after': {
                         
                            transform: hoveredCard === index 
                              ? 'translate(20%, 20%) scale(1)' 
                              : 'translate(20%, 20%) scale(0)',
                            transition: 'all 0.4s ease'
                          }
                        }}
                      >
                     <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                         {/* Icon */}
                         <Box
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '40%',
                            height: 64,
                            borderRadius: 2.5,
                            background: hoveredCard === index 
                              ? feature.gradient
                              : alpha(feature.color, 0.15),
                            color: hoveredCard === index ? '#fff' : feature.color,
                            mb: 3,
                            transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                            transform: hoveredCard === index 
                              ? 'scale(1.1) rotate(-10deg)' 
                              : 'scale(1)',
                            boxShadow: hoveredCard === index 
                              ? `0 15px 30px ${alpha(feature.color, 0.4)}` 
                              : 'none',
                            '& svg': {
                              fontSize: '1.8rem'
                            }
                          }}
                        >
                          {feature.icon}
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          {/* Title */}
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            mb: 1.5,
                            color: hoveredCard === index ? '#1e293b' : 'white',
                            fontSize: '1.25rem',
                            transition: 'color 0.3s ease'
                          }}
                        >
                          {feature.title}
                        </Typography>

                        {/* Description */}
                        <Typography
                          variant="body2"
                          sx={{
                            color: hoveredCard === index 
                              ? '#64748b' 
                              : 'rgba(255, 255, 255, 0.8)',
                            lineHeight: 1.7,
                            fontSize: '0.95rem',
                            transition: 'color 0.3s ease'
                          }}
                        >
                          {feature.description}
                        </Typography>
                        </Box>
                     </Box>
                      </Card>
                    </Fade>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Container>

        {/* CSS Animations */}
        <style jsx>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          
          @keyframes slideRight {
            0%, 100% { transform: translateX(0); }
            50% { transform: translateX(5px); }
          }
        `}</style>
      </Box>
    </Box>
  );
};

export default Features;